/* eslint-disable @nx/enforce-module-boundaries */

import MessagePage from 'v4/snippets/message';
import { ProfileLayout } from 'v4/snippets/profile/layout';
import { Card, Container } from '@mybridge/ui';
import { isMobile } from 'react-device-detect';
import Head from 'next/head';
import { useSelector } from 'react-redux';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { AuthenticatedProviders } from 'v4/snippets/providers/authenticated';
const Disk = () => {
  const { loggedIn } = useSelector((state) => state.user);
  const { globalNotifCount } = useSelector((state) => state.notifications);
  const { t } = useTranslator();
  return (
    <AuthenticatedProviders>
      <Head>
        <title>
          {loggedIn && globalNotifCount ? `(${globalNotifCount})` : ''}{' '}
          {t('navigation.myMessages') || "myMessage"} | myBridge.me
        </title>
      </Head>
      <Container w="1320px"  bg="white" maxW="100%" p={0} h="100%">
        <MessagePage />
      </Container>
    </AuthenticatedProviders>
  );
};

export default Disk;
